import React from 'react';
import useStyles from './Styles';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableRow from '@mui/material/TableRow';
import TableHead from '@mui/material/TableHead';
import Hidden from '@mui/material/Hidden';
import StoreImg from './StoreImg';
import {Tools} from './Tools';
import {Owner} from './Inc';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'

interface Props {
    list: any[],
    owner: Owner,
    pager: any,
    jump(newPage:number):void,
}

const FavListDetail = (props:Props)=> {
    const classes = useStyles();
	
	return (
		<div id="fav_list_search">
            <Table>
                <TableHead>
                    <TableRow>
                        <TableCell className={classes.tableHeadNowrap} align='center'><Hidden mdDown implementation="js">スキした</Hidden>日時</TableCell>
                        <Hidden mdDown implementation="js">
                            <TableCell className={classes.tableHeadNowrap} align='center'>画像</TableCell>
                        </Hidden>
                        <TableCell className={classes.tableHeadNowrap} align='center'>商品名</TableCell>
                        <Hidden mdDown implementation="js">
                        <TableCell className={classes.tableHeadNowrap} align='center'>BOX</TableCell>
                        </Hidden>
                    </TableRow>
                </TableHead>
                <TableBody>
            {props.list.map( (sale:any,index:number)=>{
                const key = "sale"+index;
                let fav_type_class = classes.favIcon+" ";
                //let icon = "smile";
                if( sale.type_id==="1" ){
                    fav_type_class += classes.favBackColor1;
                } else if( sale.type_id==="2" ){
                    fav_type_class += classes.favBackColor2;
                } else if( sale.type_id==="3" ){
                    fav_type_class += classes.favBackColor3;
                } else if( sale.type_id==="4" ){
                    fav_type_class += classes.favBackColor4;
                } else if( sale.type_id==="5" ){
                    fav_type_class += classes.favBackColor5;
                } else if( sale.type_id==="6" ){
                    fav_type_class += classes.favBackColor6;
                } else if( sale.type_id==="9" ){
                    fav_type_class += classes.favBackColor9;
                }
                return (
                    <TableRow key={key}>
                        <TableCell className={classes.tableCellNowrap+" "+classes.tableCellDense} sx={{verticalAlign:"middle",width:{md:'10em',sm:'6em'}}} align='center'>
                            {sale.date}<br/>
                            {sale.time}<br/>
                        </TableCell>
                        <Hidden mdDown implementation="js">
                            <TableCell className={classes.tableCellDense} align='center' style={{width:'6em'}}><StoreImg owner_id={props.owner.owner_id} img_id={sale.img_id} className="imgList"/></TableCell>
                        </Hidden>
                        <TableCell className={classes.tableCellDense}>
                            <div style={{position:"relative"}}>
                            <span className={classes.itemId}>ID:{sale.item_id}</span><br/>
                            {sale.item_name}<br/>
                            <Hidden mdUp implementation="js">
                            <span className={fav_type_class} style={{position:"absolute",top:"0.25em",right:"0",fontSize:'80%',padding:'0 0.5em',lineHeight:'1.6em'}}>
                                {sale.type_id==="1" &&
                                <FontAwesomeIcon icon="heart"/>
                                }
                                {sale.type_id==="2" &&
                                <FontAwesomeIcon icon="redo"/>
                                }
                                {sale.type_id==="3" &&
                                <FontAwesomeIcon icon="lightbulb"/>
                                }
                                {sale.type_id==="4" &&
                                <FontAwesomeIcon icon="seedling"/>
                                }
                                {sale.type_id==="5" &&
                                <FontAwesomeIcon icon="gem"/>
                                }
                                {sale.type_id==="6" &&
                                <FontAwesomeIcon icon="gift"/>
                                }
                                {sale.type_id==="9" &&
                                <FontAwesomeIcon icon="comment"/>
                                }
                                <span style={{marginLeft:'0.5em'}}>{sale.type}</span>
                            </span>
                            </Hidden>
                            </div>
                        </TableCell>
                        
                        <Hidden mdDown implementation="js">
                        <TableCell className={classes.tableCellNowrap} style={{textAlign:"center",verticalAlign:"middle",width:'8em'}}>
                            <span className={fav_type_class}>
                                {sale.type_id==="1" &&
                                <FontAwesomeIcon icon="heart"/>
                                }
                                {sale.type_id==="2" &&
                                <FontAwesomeIcon icon="redo"/>
                                }
                                {sale.type_id==="3" &&
                                <FontAwesomeIcon icon="lightbulb"/>
                                }
                                {sale.type_id==="4" &&
                                <FontAwesomeIcon icon="seedling"/>
                                }
                                {sale.type_id==="5" &&
                                <FontAwesomeIcon icon="gem"/>
                                }
                                {sale.type_id==="6" &&
                                <FontAwesomeIcon icon="gift"/>
                                }
                                {sale.type_id==="9" &&
                                <FontAwesomeIcon icon="comment"/>
                                }
                                <span style={{marginLeft:"0.5em"}}>{sale.type}</span>
                            </span>
                        </TableCell>
                        </Hidden>
                    </TableRow>
                );
            })}
                </TableBody>
            </Table>
            <div style={{padding:"1em"}}>
            {Tools.pager(props.pager,props.jump)}
            </div>


		</div>
	);
}

export default FavListDetail;
